import axios from "../request";

/**
 * 基础信息管理模块接口
*/
export default {

  // 获取全部供应商信息
  GETALLSUPPLIERDATA: () =>
    axios.get('/engineering/supplier/supplierPull'),
  // 获取全部地区信息
  GETALLCITYAREADATA: () =>
    axios.get('/engineering/city/cities'),
  // 获取全部地区信息
  GETALLCITYDATA: () =>
    axios.get('/engineering/dict/city'),
  // 获取全部楼号 楼层 宿舍信息
  GETALLBUILDDATA: () =>
    axios.post('engineering/room/pulldown'),

  /**
   * 分公司模块接口
  */

  // 查询分公司信息
  SEARCHFILIALELIST: (params) =>
    axios({
      method: 'post',
      headers: {
        pageNum: params.pageNum,
        pageSize: params.pageSize
      },
      url: '/engineering/company/findList',
      data: {
        companyName: params.companyName,
      }
    }),
  // 添加 修改 分公司信息
  INSERTFILIALEINFO: (params) =>
    axios.post('/engineering/company/addCompany', params),
  // 删除分公司信息
  DELETEFILIALEINFO: (params) =>
    axios.post('/engineering/company/delete', params),
  /**
   * 收货人模块接口
  */

  // 查询收货人信息
  SEARCHCONSIGNEELIST: (params) =>
  axios({
    method: 'post',
    headers: {
      pageNum: params.pageNum,
      pageSize: params.pageSize
    },
    url: '/engineering/reciver/findList',
    data: {
      proId: params.proId,
      segmentId: params.segmentId,
      reciverName: params.reciverName
    }
  }),
  // 添加收货人信息
  INSRTCONSIGNEEINFO: (params) =>
    axios.post('/engineering/reciver/addReciver', params),
  // 修改收货人信息
  UPDATECONSIGNEEINFO: (params) =>
    axios.post('/engineering/reciver/addReciver', params),
  // 删除收货人信息
  DELETECONSIGNEEINFO: (params) =>
  axios.post('/engineering/reciver/delete', params),


  /**
   * 模具模块接口
  */
  // 根据项目获取块号 尺寸 转向 配筋 注浆孔信息
  getProjectSystemInfoData: (params) =>
    axios.get('engineering/project/projectInfo', {params}),

  // 查询模具信息
  SEARCHMOULDINFOLIST: (params) =>
    axios({
      method: 'post',
      headers: {
        pageNum: params.pageNum,
        pageSize: params.pageSize
      },
      url: '/engineering/mould/findList',
      data: {
        proId: params.proId,
        mouldType: params.mouldType,
        mouldNum: params.mouldNum,
        supplierId: params.supplierId,
        status: params.status,
      }
    }),
  // 添加模具信息
  INSERTMOULDINFO: (params) =>
    axios.post('/engineering/mould/addMould', params),
  // 修改模具信息
  UPDATEMOULDINFO: (params) =>
    axios.post('/engineering/mould/addMould', params),
  // 删除模具信息
  DELETEMOULDINFO: (params) =>
    axios.post('/engineering/mould/delete', params),

  /**
   * 宿舍管理模块接口
  */

  // 查询楼号列表信息
  SEARCHBUILDINGNOLIST: (params) =>
    axios({
      method: 'post',
      url: '/engineering/build/findList',
      headers: {
        pageNum: params.pageNum,
        pageSize: params.pageSize
      },
      data: {
        buildId: params.buildId
      }
    }),
  // 添加楼号信息
  INSERTBUILDINGNOINFO: (params) =>
    axios.post('/engineering/build/addBuild', params),
  // 修改楼号信息
  UPDATEBUILDINGNOINFO: (params) =>
    axios.post('/engineering/build/addBuild', params),
  // 删除楼号信息
  DELETEBUILDINGNOINFO: (params) =>
    axios.post('/engineering/build/delete', params),
  
  // 查询所有楼层信息
  SEARCHFLOORLIST: (params) =>
    axios({
      method: 'post',
      url: '/engineering/room/findList',
      headers: {
        pageNum: 1,
        pageSize: 1000000
      },
      data: params
    }),
  // 添加楼层与房间信息
  INSERTFLOORANDROOMINFO: (params) =>
    axios.post('/engineering/room/addRoom', params),
  // 修改楼层与房间信息
  UPDATEFLOORANDROOMINFO: (params) =>
    axios.post('/engineering/room/addRoom', params),
  // 删除楼层与房间信息
  DELETELOORANDROOMINFO: (params) =>
    axios.post('/engineering/room/deleteFloor', params),
  // 查询楼层房间信息
  SEARCHROOMINFOLIST: (params) =>
    axios({
      method: 'post',
      url: '/engineering/room/findRoomList',
      headers: {
        pageNum: 1,
        pageSize: 1000000
      },
      data: params
    }),
}